<div *ngIf="isSettingLoaded$.value; else loading">
  <form [formGroup]="supportedWellFormGroup" (ngSubmit)="addSupportedWell()" class="new-po-form">
    <mat-form-field class="form-field w-full">
      <mat-select formControlName="fracs" placeholder="Select well">
        <mat-option *ngIf="isFracListSelectionEmpty" [value]="null">
          <span class="text-gray-500">No wells available</span>
        </mat-option>
        <mat-option *ngFor="let frac of fracList$ | async; trackBy: fracList$ | trackByKey: 'id'" [value]="frac.id">
          {{ frac.jobName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="form-field w-full">
      <input
        matInput
        placeholder="Billable Mileage"
        formControlName="billableMileage"
        autocomplete="off"
        type="number"
        min="0"
      />
      <mat-hint *ngIf="billableMileage$ | async as billableMileage"
        >SANDi recommends setting billable mileage to {{ billableMileage | i18nPlural: milePluralMapping }}.</mat-hint
      >
    </mat-form-field>
    <mat-form-field class="form-field w-full">
      <input
        matInput
        placeholder="PO Line Item Number"
        formControlName="poLineItemNumber"
        [required]="isPOLineItemNumberMandatory$.value"
        autocomplete="off"
        type="text"
        saAutomatedSelector="fcpo_add__poLineItemNumber"
      />
    </mat-form-field>
    <div class="w-full flex justify-between">
      <button type="button" mat-flat-button color="warn" (click)="closeDialog()">
        <span class="text-white">Cancel</span>
      </button>
      <button type="submit" mat-flat-button color="primary">
        <span class="text-white">Save</span>
      </button>
    </div>
  </form>
</div>

<ng-template #loading>
  <div class="w-full flex justify-center">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
</ng-template>
